module.exports = "<footer class=\"app-footer\">\n  <span>{{ app_name }}</span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/jacobo/proyectos/venta-extranet/src/app/core/components/layout/footer/footer.component.html
// module id = ../../../../../src/app/core/components/layout/footer/footer.component.html
// module chunks = main